import { ApolloClient, InMemoryCache } from "@apollo/client"
import { setContext } from "@apollo/client/link/context"
import Cookies from "js-cookie"
import { createUploadLink } from "apollo-upload-client"

const httpLink = createUploadLink({
  uri: "/graphql",
})

const authLink = setContext((_, { headers }) => {
  return {
    headers: {
      ...headers,
      "x-csrftoken": Cookies.get("csrftoken"),
    },
  }
})

export const client = new ApolloClient({
  link: authLink.concat(httpLink),
  cache: new InMemoryCache(),
})
